// src/hooks/useOrderMedia.js
import { useState, useEffect } from 'react';
import api from '../services/api';

export default function useOrderMedia(orderId) {
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!orderId) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const fetchMedia = async () => {
      try {
        const data = await api.getOrderItems(orderId);
        
        if (!cancelled) {
          // Extract media array from chapters[0]
          const fetchedMedia = data?.chapters?.[0]?.media || [];
          setMediaList(fetchedMedia);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to fetch media');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchMedia();

    // Cleanup function to prevent setting state on unmounted components
    return () => {
      cancelled = true;
    };
  }, [orderId]);

  return {
    mediaList,
    loading,
    error,
  };
}